// extracted by mini-css-extract-plugin
module.exports = {"questions":"styles_questions__r7fB4"};